import ExcelParser from "./RecoUploadExcelComponent";

const RecoUploadPage = () => {

  return (
    <div style={{ display: 'flex', flexDirection: 'column', margin: '20px'}}>
      <ExcelParser/>
    </div>
  )
}

export default RecoUploadPage